<template>
  <div class="meta-head">
    <!-- TODO добавить перевод -->
    <div class="wrapper">
      <div class="title">
        <!-- <input
          type="text"
          class="h-empty-input"
          v-model="form.name"
          v-autowidth="{
            maxWidth: '300px'
          }"
          :readonly="!canEdit"
          placeholder="Test name"
        >
        <template v-if="!isCreating">
          <button @click="edtiOn" v-if="!edit" class="btn">
            <i class="material-icons">
              edit
            </i>
          </button>
          <button @click="edtiOff" v-else class="btn">
            <i class="material-icons">
              save
            </i>
          </button>
        </template> -->
      </div>

      <div class="buttons">

        <template v-if="isCreating">
          <app-btn
            class="create"
            @click="create"
            :loading="create_loading"
            :disabled="form.textureId <= 0 || form.name == null || form.cec <= 0 || form.cec == null"
          >
            {{ $ml.get(`save`) }}
          </app-btn>
        </template>

        <template v-else>
          <app-btn
            class="save"
            @click="save"
            :loading="edit_loading"
            :disabled="form.textureId <= 0 || form.name == null || form.cec <= 0 || form.cec == null"
          >
            {{$ml.get(`save`)}}
          </app-btn>
          <app-btn
            @click="downloadReport"
            :loading="report_loading"
            :disabled="form.textureId <= 0"
          >
            {{ $ml.get(`Download report`) }}
          </app-btn>
          <!-- <app-btn
            styling="outline"
            class="print"
          >
            {{$ml.get(`Print test`)}}
          </app-btn> -->
          <app-btn
            class="delete"
            danger="true"
            @click="remove"
            :loading="delete_loading"
          >
            {{$ml.get(`Delete test`)}}
          </app-btn>
        </template>
      </div>
    </div>
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        :html-to-pdf-options="{margin: [5, 0, 5, 0], filename: $store.getters['tests/soil/form'].name + '.pdf', image: {type: 'png', quality: 1}}"
        
 
        @hasDownloaded="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content">
            <div class="report-wrapper">
              <div class="report" v-if="reportData.soilTest">
                <div class="soil-test">
                  <div class="html2pdf__page-break">
                    <MainHeader>
                      {{$ml.get('Soil test')}}
                    </MainHeader>
                    
                    <GeneralInfo/>
                    <Parameters/>
                    <Interpretations/>
                  </div>
                  <div class="html2pdf__page-break">
                    <NutChart/>
                  </div>
                  
                </div>
            </div>
            </div>
        </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ErrorHandlerMixin } from '@/mixins/error-handler.mixin'
import { SoilTestAPI } from '@/api';
import VueHtml2pdf from 'vue-html2pdf'
import GeneralInfo from '@/views/tests/reports/soil/GeneralInfo';
import NutChart from '@/views/tests/reports/soil/NutChart';
import Interpretations from '@/views/tests/reports/soil/Interpretations';
import Parameters from '@/views/tests/reports/soil/Parameters';
import MainHeader from '@/views/tests/reports/common/MainHeader';

export default {
  mixins: [ ErrorHandlerMixin ],
  data() {
    return {
      edit: false,
      create_loading: false,
      edit_loading: false,
      delete_loading: false,
      report_loading: false,
      reportData: {},
    }
  },
  components: {
    VueHtml2pdf,
    GeneralInfo,
    NutChart,
    Interpretations,
    Parameters,
    MainHeader
  },
  methods: {
    hasGenerated(e) {
      this.loading = false;
      // this.$store.commit('pdf/removeData');
      this.$router.push({path: `/dashboard/tests/soil/${this.reportData.soilTest.data.id}/report`});
      this.report_loading = false;
    },


    downloadReport() {
      this.report_loading = true;
      
      return SoilTestAPI.downloadReport(this.form.id).then(res => {
          // var blob = new Blob([ res.data ], { type: 'application/pdf' });
          // var link = document.createElement('a');
          // link.href = window.URL.createObjectURL(blob);
          // link.download = this.form.name + '.pdf';
          // link.click();
          console.log(res)
          this.$root.data = this.reportData = res.data.data;
            this.$store.dispatch('pdf/setData', res.data.data);
            this.$refs.html2Pdf.generatePdf();

        })
        .catch(error => {
          this.$notify({
            group: "notices",
            title: this.$ml.get("Soil texture field is required."),
            type: "warn",
          });
          this.report_loading = false;
        })
    },


    validate() {

      let error = false;

      // if(!this.form.farmId) {
      //   error = this.$ml.get(`Please select farm`);
      // }
      // else if(!this.form.fieldId) {
      //   error = this.$ml.get(`Please select field`);
      // }
      if(!this.form.methodId) {
        error = this.$ml.get(`Please select soil lab`);
      }
      // else if(!this.form.textureId) {
      //   error = this.$ml.get(`Please select soil texture`);
      // }

      if(error) {
        this.$notify({
          title: this.$ml.get(error),
          type: 'error',
          group: 'notices',
        });
        return false;
      } else {
        return true;
      }
    },


    async create() {

      if(!this.validate()) {
        return;
      }

      this.create_loading = true;

      this.$store.dispatch('tests/soil/createTest').then(test => {
        this.$router.replace('/dashboard/tests/soil/' + test.id);
        // this.$store.commit('modals/prompt/open', {
        //   onAccept: () => {
        //     this.$router.replace('/dashboard/programs/list/0');
        //   },
        //   text: this.$ml.get(`Do you want to create program now?`),
        // });
      })
        .catch(this.handleErrorAsNotifications)
        .finally(() => {
          this.create_loading = false
        });
    },
    save() {

      if(!this.validate()) {
        return;
      }

      this.edit_loading = true;

      this.$store.dispatch('tests/soil/updateTest').then(res => {
        this.$notify({
          title: this.$ml.get(`The test was successfully saved`),
          type: 'success',
          group: 'notices',
        });
      })
        .catch(this.handleErrorAsNotifications)
        .finally(() => {
          this.edit_loading = false
        });
    },
    remove() {
      this.$store.commit('modals/prompt/open', {
        onAccept: () => {
          this.delete_loading = true;
          this.$store.dispatch('tests/soil/deleteTest').then(res => {
            this.$notify({
              type: 'success',
              group: 'notices',
              title: this.$ml.get(`The test was successfully saved`),
            });
            this.$router.replace('/dashboard/tests');
          }).finally(() => {
            this.delete_loading = false;
          });
        },
        text: this.$ml.get(`Are you sure?`),
      });
    },
    edtiOn() {
      this.edit = true;
    },
    edtiOff() {
      this.edit = false;
    },
  },
  computed: {
    ...mapGetters({
      isCreating: 'tests/soil/isCreating',
      form: 'tests/soil/form',
    }),
    canEdit() {
      return this.isCreating || this.edit;
    },
  }
}
</script>

<style lang="scss">
.report {
  width: 100%;
  margin: 0 auto;
  background: #fff;
  flex-direction: column;
  overflow-x: hidden;
  padding: 20px;
}
.report-wrapper {
  display: flex;
  flex-direction: column;
}
.report-header {
  padding: 23px 0 27px;
}
.section {
  padding: 30px;
}

.meta-head {
  min-height: 80px;

  display: flex;
  flex-direction: row;
  align-items: center;

  .wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;

    width: 100%;
    height: 50px;
    padding-bottom: 10px;

    .title {
      position: relative;
      input {
        color: #4C5056;
        font-size: 33px;
        line-height: 100%;
        font-weight: bold;
        border-bottom: 1px solid $mainGreen;

        &[readonly] {
          border-color: transparent;
        }
      }

      .btn {
        position: absolute;
        width: 20px;
        height: 20px;
        right: -25px;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        padding: 0;
        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;
        background: $mainGreen;
        border: 0;
        i {
          font-size: 12px;
          color: #fff;
        }
      }
    }

    .buttons {
      display: flex;
      flex-direction: row;

      .delete {
        margin-left: 20px;
      }

      .save {
        margin-right: 20px;
      }
    }
  }
}

</style>
